// extracted by mini-css-extract-plugin
module.exports = {"OTPboxesContainer":"OTPinput_OTPboxesContainer__2gsXP","OTPbox":"OTPinput_OTPbox__3GlkV"};